import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export interface DefaultPhotoRequirementInput {
  name: string;
  isRequired: boolean;
  order: number;
}

export const setDefaultPhotoRequirementsAtom = createMutationAtomFactory(
  'trade.setDefaultPhotoRequirements',
  (params: { photoRequirements: DefaultPhotoRequirementInput[] }) => ({
    setDefaultPhotoRequirements: {
      __args: {
        photoRequirements: params.photoRequirements,
      },
      id: true,
      createdById: true,
      name: true,
      isRequired: true,
      order: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
